import {
  LOGIN_USER,
  LOGIN_SUCCESS,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  API_ERROR,
  GET_ME,
  GET_ME_SUCCESS,
  GET_ME_FAIL,
} from './actionTypes';

const initialState = {
  user: null,
  isUserLogout: false,
  error: '',
  loading: false,
};

const login = (state = initialState, action) => {
  switch (action.type) {
    case GET_ME:
      return {
        ...state,
        loading: true,
      };

    case GET_ME_SUCCESS:
      return {
        ...state,
        user: action.payload,
        loading: false,
      };
    case GET_ME_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    case LOGIN_USER:
      state = {
        ...state,
        loading: true,
      };
      break;
    case LOGIN_SUCCESS:
      state = {
        ...state,
        loading: false,
        isUserLogout: false,
      };
      break;
    case LOGOUT_USER:
      state = { ...state };
      break;
    case LOGOUT_USER_SUCCESS:
      state = { ...state, isUserLogout: true };
      break;
    case API_ERROR:
      state = {
        ...state,
        error: action.payload,
        loading: false,
        isUserLogout: false,
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default login;
